// Random String
import {randomString} from './_random-string';

// TODO: Settings

// Add smooth scroll for links with a URI starting with "#" or
// create a modal for linsk with a URI starting with "#modal:".
const $hashLink = $('a');
var $siteheader = $('.site-header').height();

// Get the height of the site-header. 
$(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {
    // TODO create component to track and set header height.
    $siteheader = $('.site-header').height();
});

// Find links with a URL beginning with "#".
// TODO: Use forEach instead of jQ each().
$hashLink.each(function(i) {

    let $el = $(this);
    
    // Add smooth scroll if href starts with "#" OR Create a modal for "#modal" fragments
    if ( $el.attr('href') && $el.attr('href').substr(0,6) != '#modal' && $el.attr('href').substr(0,1) == '#' ) {
        
        new Foundation.SmoothScroll( $el, {
        
            offset: $siteheader
            
        });

    } 

    // Create and open a reveal modal if href starts with "modal:"
    else if ( $el.attr('href') && $el.attr('href').substr(0,6) == '#modal' ) {
        
        let modalSlug = $el.attr('href').replace('#modal:', '');
        
        let endPoint = `/wp-json/wp/v2/modal/?slug=${modalSlug}`;
        
        if ( window.location.hostname == "dev1.nvision.co" || window.location.hostname == 'localhost' ) {
            endPoint = `http://dev1.nvision.co/nvision-boilerplate/wp-json/wp/v2/modal/?slug=${modalSlug}`;
        }

        $.get(endPoint,{},function(data, textStatus, jqXHR) {
            
            // Request successful
            if ( textStatus == 'success' ) {
                
                // Generate modal ID
                var modalID = `modal-${randomString()}`;
                
                // Get modal HTML
                var _nv_wysiwyg_modalHTML = data[0].content.rendered;                
                
                // Create new Reaveal Instance
                // Set up modal trigger on link
                $el.removeAttr('href').attr('data-open', modalID).addClass('reveal--wysiwyg');
                
                $el.after(`
                    <div id="${modalID}" class="modal-component modal-component--wysiwyg reveal" data-reveal data-animation-in="fade-in" data-animation-out="fade-out" data-reset-on-close="true">
                        <div class="modal-component__content">
                            ${_nv_wysiwyg_modalHTML}
                            <button class="close-button" data-close aria-label="Close modal" type="button">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                `);

            }

        });

    }

    // At the end of the loop reinit Foundation to account for the new HTML added.
    if ( $hashLink.length - 1 == i ) {

        setTimeout(function() {
          
            $(document).foundation();

        }, 2000);

    }

});